<template>
	<div class="father-content">
		<transition name="product-anim"  enter-active-class="animate__animated animate__backInUp" leave-active-class="animate__animated animate__backOutDown">
			<product-detail 
			v-if="product_selected" 
			:product="product_selected"
			@closeProductDetail="product_selected = $event">	
			</product-detail>
			<cart 
				v-if="content_cart"
				@closeCartDetail= "content_cart = $event">		
			</cart>
		</transition>
		<div class="content-category" v-show="!product_selected && !content_cart">
			<div class="nav-bar">
				<div class="back">
					<i class="fas fa-long-arrow-alt-left" @click="close()"></i>
				</div>
				<div class="nombre-categoria">
					<h4>{{ name_category }}</h4>
				</div>
				<div class="cart">
					<!--<i class="fas fa-shopping-cart"></i>-->
				</div>
			</div>
			<div class="product-per-category">
				<div class="single-product" v-for="product in products">
					<!--<picture>
	                    <source alt="pwebp" v-bind:srcset="url_images+product.galery_images[0]" type="image/webp"/>
	                    <source alt="pjp2" v-bind:srcset="url_images+product.galery_images[2]" type="image/jp2"/>
	                    <img alt="pjpg" rel="preconnect" v-bind:src="url_images+product.galery_images[1]">   
	                </picture>-->
	                <img alt="pjpg" rel="preconnect" v-lazyload :data-src="url_images+product.galery_images[0]" @click="openDetail(product)"> 
					<div class="detail-product">
						<h4 class="disponible" v-show="product.stock_end[0].stock > 0 && id_companie == 6798">Disponibles: {{product.stock_end[0].stock}}</h4>
						<h4 class="name-category">{{ name_category }}</h4>
						<h4 class="name-product">{{ product.name }}</h4>
						<div class="old-value" v-show="status_old_price">
							<h4 class="old-price" v-show="product.old_price > 0">${{ Intl.NumberFormat("de-DE").format(product.old_price) }}</h4>
							<h4 class="price"><span v-show="product.old_price > 0">-</span> ${{ Intl.NumberFormat("de-DE").format(product.value_sale) }}</h4>
						</div>
						<div class="normal-value" v-show="!status_old_price && product.old_price == 0">
							<h4 class="price">${{ Intl.NumberFormat("de-DE").format(product.value_sale) }}</h4>
						</div>
						<div class="temp-button" v-if="product.stock_end.length > 0 && id_companie == 6798">
							<button class="custom-add" v-if="!product.status_variants && product.stock_end[0].stock > 0" @click="addToCart(product)"><i class="fas fa-shopping-cart"></i> Añadir al carrito </button>
						</div>
					</div>
					<div class="agotado-container" v-if="product.stock_end.length > 0 && id_companie == 6798">
						<div class="agotado" v-if="product.stock_end[0].stock == 0">
	      					<span>Agotado</span>
	    				</div>
					</div>
				</div>
			</div>
			<div id="cart-interna" class="cart-1" data-totalitems="1">
		  		<!--<i class="fas fa-shopping-cart" @click="openCart(ProductList)"></i>-->
		  		<i class="fas fa-shopping-cart" @click="openCartInterna()"></i>
			</div>
		</div>
		
	</div>
</template>


<style lang="scss" scoped>

	.disponible{
		width:100%;
		text-align:left;
		font-size:13px;
		font-weight:500;
	}

	.custom-add{
		width: 100%;
		height: auto;
		font-size:14px;
		border:none;
		padding: 7px 0px;
		margin-bottom: 8px;
	}

	.old-value{
		width: 100%;
		display:flex;
		justify-content: flex-start;
		align-items:center;
	}

	.normal-value{
		width:100%;
		text-align: left;
	}

	.agotado{
	  background: #E33838;
	  padding:8px;
	  color: #fff;
	  position: absolute;
	  text-align:center;
	  top:30%;
	  left:0;
	  right:0;
	  border-radius:3px;
	}


	.content-category{
		width: 100%;
		padding: 0;
		margin: 0;
	} 

	.nav-bar{
		display: flex;
		justify-content: center;
		width: 100%;
		padding-top: 20px;
		padding-bottom: 13px;
		box-shadow: 0px 0px 4px 0px rgba(71,70,71,1);
		z-index: 2;
	}
	.back{
		width: 30%;
		text-align: left;
		align-items: center;
	}
	.back i{
		font-size: 22px;
	}
	.nombre-categoria{
		width: 30%;
		text-align: center;
		vertical-align: middle;
	}
	.nombre-categoria h4{
		font-size: 21px;
	}
	.cart{
		width: 30%;
		text-align: right;
		vertical-align: middle;
	}
	.cart i{
		font-size: 21px;
	}

	.product-per-category{
		padding-top: 25px;
		width: 100%;
		padding-left: 10px;
		padding-right: 10px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.single-product{
		width: 48%;
		margin: 0;
		padding-bottom: 15px;
		position: relative;
	}

	.single-product img{
		width: 100%;
		height: auto;
		border-left: 1px solid #F1F1F1;
		border-right: 1px solid #F1F1F1;
		border-top: 1px solid #F1F1F1;
	}

	.detail-product{
		text-align: left;
		padding-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		border-left: 1px solid #F1F1F1;
		border-right: 1px solid #F1F1F1;
		border-bottom: 1px solid #F1F1F1;
	}

	.name-category{
		font-size: 12px;
		font-weight: 400;
	}

	.name-product{
		font-size: 15px;
		font-weight: 500;
		margin-top: -5px;
	}

	.price{
		font-size: 14px;
		font-weight: 600;
		color: #4FB891;
		margin-top: -2px;
	}

	.old-price{
		font-size: 14px;
		font-weight: 600;
		color: #9C9C9C;
		margin-top: -2px;
		text-decoration-line: line-through;
		margin-right: 3px;
	}

	.cart-1{
		position:fixed;
		top:10px;
		right:26px;
		width:40px;
		height:40px;
		background:#fff;
		display:flex;
		align-items:center;
		justify-content:center;
		border-radius:5px;
		transition: all .5s ease-in-out;
	    i {
	    font-size:20px;
	    color:#292d48;	
	  	}
	  	&:before {
	    content:attr(data-totalitems);
	    font-size:12px;
	    font-weight:600;
	    position:absolute;
	    top:-2px;
	    right:-7px;
	    background:#2bd156;
	    line-height:21px;
	    padding:0 5px;
	    height:20px;
	    min-width:20px;
	    color:white;
	    text-align:center;
	    border-radius:24px;
	  	}
	  	&.shake {
	    animation: shakeCart .4s ease-in-out forwards;
	  		}
	}
	.cart-interna {
		  position:fixed;
		  top:10px;
		  right:26px;
		  width:40px;
		  height:40px;
		  background:#292d48;
		  display:flex;
		  align-items:center;
		  justify-content:center;
		  border-radius:5px;
		  transition: all .5s ease-in-out;
	    i {
	    font-size:20px;
	    color:white;
	  }
	  &:before {
	    content:attr(data-totalitems);
	    font-size:12px;
	    font-weight:600;
	    position:absolute;
	    top:-6px;
	    right:-10px;
	    background:#2bd156;
	    line-height:21px;
	    padding:0 5px;
	    height:20px;
	    min-width:20px;
	    color:white;
	    text-align:center;
	    border-radius:24px;
	  }
	  &.shake {
	    animation: shakeCart .4s ease-in-out forwards;
	  }
	}

	@keyframes xAxis {
	  100% {
	    transform: translateX(calc(50vw - 105px));
	  }
	}

	@keyframes yAxis {
	  100% {
	    transform: translateY(calc(-96vh + 75px));
	  }
	}

	@keyframes shakeCart {
	  25% {
	    transform:translateX(6px)
	  }
	  50% {
	    transform:translateX(-4px);
	  }
	  75% {
	    transform:translateX(2px);
	  }
	  100% {
	    transform:translateX(0);
	  }
	}
</style>

<script>
	import Vue from 'vue';
	import axios from 'axios';
	import Vuesax from 'vuesax';
	import 'vuesax/dist/vuesax.css'; //Vuesax styles
	import ProductDetail from './ProductDetail'; 
	import $ from 'jquery';
	import Cart from './Cart';
	import lazyload from '../directives/lazyload';
	export default {
	   props: ['category'],
	   components: {
	   	ProductDetail,
	   	Cart
	   },
	   data() {
		  	return {
		  		id_companie: JSON.parse(localStorage.getItem('id_companie')),
		  		status_old_price: JSON.parse(localStorage.getItem('old_price_status')),
		  		url_images: localStorage.getItem('url_images'),
		  		product_selected : false,
		  		content_cart: false	,
		  		category_data : "",
		  		name_category: "",
		  		products: [],
		  		productList: [],
		  		contador: 0,
		  		product_added: false	  		
		  	}
	    },
	    directives:{
    		lazyload
  		},
	  watch:{
	  	content_cart: function(value){	  		
	  		$('#cart-interna').addClass('shake').attr('data-totalitems', this.getListStorage().length);
	  	},
	  	product_selected: function(value){	  		
	  		$('#cart-interna').addClass('shake').attr('data-totalitems', this.getListStorage().length);
	  	},
	  	product_added: function(value){	  		
	  		$('#cart-interna').addClass('shake').attr('data-totalitems', this.getListStorage().length);
	  	}
	  },
	  methods:{
	  	addToCart(product){
	  		let product_cart = {
				'id' : product.id,
				'name' : product.name,
				'image' : localStorage.getItem('url_images') + product.galery_images[0],
				'description' : product.description,
				'value_sale' : product.value_sale,
				'quantity' : 1,
				'combination' : false,
				'descuento': 0,
				'estado' : true
			}
			this.productList.push(product_cart);
			for(let i=0; i < localStorage.length;  i++){
				let llave = localStorage.key(i);
				if (llave.includes(`Cart_ ${localStorage.getItem('id_companie')}`)) {
					let lista = JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
					let search = lista.find(item => item.id == product_cart.id);
					let combination = lista.find(item => item.combination === product_cart.combination);

					if(search && combination){
						//EDIT
						let position = lista.indexOf(search)
						lista.splice(position, 1, product_cart)
					}else{
						lista.push(product_cart);
					}
					
					localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(lista));
					this.contador ++;
					this.product_added = !this.product_added;
				}
			}
			this.getListStorage();
			if (this.contador == 0) {
				//localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(this.ProductList));
				localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(this.productList));
				this.product_added = !this.product_added;
			}
	  	},
	  	getListStorage(){
			for(let i=0; i < localStorage.length;  i++){
				let llave = localStorage.key(i);
				if (llave.includes(`Cart_ ${localStorage.getItem('id_companie')}`)) {
					return JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
				}	
			}
			return []
		},
	  	close(){
  			this.$emit('closeCategory',false);
  		},
  		openCartInterna(){
  			this.content_cart = true; 
  		},
  		GetProductsByCategories(){
  			var data = new FormData();
        	data.append('id_category',this.category.id_category);
  			axios.post('https://back.vinapp.co/api/category/post-product-Categories-end-v2',data)
  			.then(res => {
  				var self = this;
  				self.category_data = res.data.categories;
  				self.name_category = self.category_data[0].name;
  				self.products = self.category_data[0].products;
  			})
  			.catch(err => {
            	console.log(err);      
        	});
  		},
	  	openDetail(product){
	  		if (this.id_companie == 6798){ 
	  			if(product.stock_end[0].stock > 0)this.product_selected = product;
	  		}else{
	  			this.product_selected = product
	  		}
	  		console.log(this.product_selected);
	  	},
	  	validateStock(product){
	  		let bandera = false;
	  		console.log(product)
	  			product.stock.forEach((item) => {
	  				if (item.stock > 0) bandera = true
	  			});
	 		return bandera;
	  	},
	  	validateStock2(product){
	  		return product.stock.filter(element => element.stock > 0).length > 0 ? false : true
	  	}
	  },
	  
	  mounted() {
	  	localStorage.removeItem("id_coupon");
		localStorage.removeItem("coupon_text");
		localStorage.removeItem("order_discount");	  	
	  	this.GetProductsByCategories();
	  	this.category.products.map((item) => {
	  	 item.sale_off = this.validateStock2(item); 
	  	})
	  	 $(window).scrollTop(0);
	  	 var self = this;
		 $('#cart-interna').addClass('shake').attr('data-totalitems', this.getListStorage().length);
		 let carrito = document.querySelector('.cart-1');
		 window.onscroll = function(){
		  	var top = window.scrollY;
		  	if (top == 0) {
		  		carrito.classList.remove('cart-interna');	
		  		carrito.classList.add('cart-1');
		  	}else{
		  		carrito.classList.remove('cart-1');
		  		carrito.classList.add('cart-interna');
		  	}
		}
	}
}
</script>